import { AppStateType } from '@xarvio/frontend-core-state/lib/types';
import { createSelector } from 'reselect';

export const featureFlagsSelector = (state: AppStateType) => {
  return state.featureFlags;
};

export const defaultFeaturesSelector = createSelector(
  featureFlagsSelector,
  (featureFlags) => featureFlags.defaultFeatures,
);

export const regionalFeaturesSelector = createSelector(
  featureFlagsSelector,
  (featureFlags) => featureFlags.regionalFeatures,
);

export const tokenFeaturesSelector = createSelector(
  featureFlagsSelector,
  (featureFlags) => featureFlags.tokenFeatures,
);

export const qaFeaturesSelector = createSelector(
  featureFlagsSelector,
  (featureFlags) => featureFlags.qaFeatures,
);
